<div class="widget" [ngClass]="{'loader-shown': loading, 'failed-to-load': failedToLoad}">
  <div class="widget-failed-to-load" [attr.aria-hidden]="failedToLoad ? 'false' : 'true'">
    <div class="content">
      <div class="content-inner">
        <span class="icon material-icons" aria-hidden="true">priority_high</span>
        <h3 class="title">Error</h3>
        <p class="text-content">Unable to load data. Please try again.</p>
      </div>
      <button class="button button-secondary button-secondary--smaller" (click)="reloadWidget()" aria-label="Reload Widget">Reload</button>
    </div>
  </div>
  <div class="widget-loader widget-loader-admin-review" [attr.aria-hidden]="loading ? 'false' : 'true'">
    <div class="widget-loader-header">
      <div class="loader-element loader-icon"></div>
      <div class="loader-element loader-title"></div>
    </div>
    <div class="widget-loader-content">
      <div class="loader-element image-loading"></div>
      <div class="loader-element text-loading"></div>
      <div class="loader-element small-loading"></div>
    </div>
  </div>
  <div class="widget-header" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <span class="custom-icon" aria-hidden="true">
      <span class="icon material-icons-round">task</span>
    </span>
    <span class="title">{{ stageName }}</span>
  </div>
  <div class="widget-content" [attr.aria-hidden]="failedToLoad ?? loading ? 'true' : 'false'">
    <div *ngIf="!stageId">Not connected to a stage</div>

    <div *ngIf="stageId && !isResultsForParticipantsReleased" class="custom-message">
      <span class="icon material-icons reviewed" aria-hidden="true">search</span>
      <p>All submitted applications are being reviewed for eligibility.</p>
      <small></small>
    </div>

    <div *ngIf="stageId && isEliminated && isResultsForParticipantsReleased" class="custom-message">
      <span class="icon material-icons passed-deadline" aria-hidden="true">cancel</span>
      <p>System Message</p>
      <small>We regret to inform you that you have been eliminated from the competition at this stage.</small>
    </div>

    <div *ngIf="stageId && !isEliminated && isValid === false && isResultsForParticipantsReleased" class="custom-message">
      <span class="icon material-icons passed-deadline" aria-hidden="true">cancel</span>
      <p>Your application is deemed invalid and will not move forward in the competition.</p>
    </div>

    <div *ngIf="stageId && !isEliminated && isValid === true && isResultsForParticipantsReleased" class="custom-message">
      <span class="icon material-icons submitted" aria-hidden="true">check_circle</span>
      <p>Congratulations! Your application is moving on to the next phase of the competition.</p>
    </div>

    <button
      class="button button-primary"
      *ngIf="stageId && (showFinalComment || showTurndownReason)"
      attr.aria-label="Learn more"
      (click)="showMoreInfoDialog()"
    >         
      Learn More
    </button>
    
  </div>
</div>